import setAllItemsState from "../setAllItemsState";
import { ITEM_STATE_SAVED_ITEM_LOADED } from "../../../constants";
import createNewItemsState from "./createNewItemsState";
import mergeNewItemsWithItemsState from "./mergeNewItemsWithItemsState";
import hasDuplicateItemIds from "./hasDuplicateItemIds";

export default (
  state,
  {
    payload: {
      offset,
      limit,
      offsetId,
      savedItems: { savedItemProducts, itemCount }
    }
  }
) => {
  const shouldRefreshItems =
    itemCount !== state.displayableItemCount ||
    hasDuplicateItemIds(savedItemProducts, state.items);

  const incomingItems = setAllItemsState(
    savedItemProducts,
    ITEM_STATE_SAVED_ITEM_LOADED
  );

  const items = shouldRefreshItems
    ? createNewItemsState({
        offset,
        limit,
        itemCount,
        incomingItems
      })
    : mergeNewItemsWithItemsState({
        items: state.items,
        offset,
        limit,
        offsetId,
        incomingItems
      });

  return {
    ...state,
    displayableItemCount: itemCount,
    items
  };
};
